import { connect } from 'react-redux';
import { fetchQCSideNav } from 'ducks/sidenav';

import { HEADER_HEIGHT, TOP_NAV_HEIGHT } from 'style/dimensions';

import { groupDefinitionsByCategory } from 'utils/dictionaryHelpers';

import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import SideNav from 'components/SideNav';
import withRouting from 'utils/withRouting';
import { Outlet } from 'react-router';

class Browse extends React.Component {
  componentDidMount = () => {
    const {
      dispatch,
      entityDefinitions: { defs },
      router: {
        params: { program, project },
      },
    } = this.props;

    defs.length && this.getSideNavData({
      defs,
      dispatch,
      program,
      project,
    });
  }

  componentDidUpdate = (prevProps) => {
    const {
      dispatch,
      entityDefinitions: { defs },
      router: {
        location: { pathname },
        params: { program, project },
      },
    } = this.props;

    const {
      entityDefinitions: { defs: oldDefs },
    } = prevProps;

    const oldPath = this.sectionName();
    const path = this.sectionName(pathname);

    (oldPath !== path || (!oldDefs.length && defs.length))
     && this.getSideNavData({
       defs,
       dispatch,
       path,
       program,
       project,
     });
  }

  getSideNavData = ({
    defs,
    dispatch,
    program,
    project,
  }) => {
    dispatch(fetchQCSideNav({ program, project, defs }))
  };

  sectionName = (path) => {
    const { router: { location: { pathname } } } = this.props;
    return (path || pathname).split('/')[3];
  }

  render(): React.Element {
    const {
      entityDefinitions: { defs, isFetching },
      notifications,
      projects,
      router: {
        params,
      },
      sidenav,
    } = this.props;

    const path = this.sectionName();
    const projectId = `${params.program}-${params.project}`;
    const project = projects.items.find(p => p.project_id === projectId);

    const defsByCategory = groupDefinitionsByCategory({ defs });

    return (
      <Row>
        <Column
          style={{
            flex: 1,
            overflow: 'hidden',
            width: '100%',
          }}
          >
          <Row
            style={{
              height: `calc(100vh - ${(1 + notifications.filter(n => !n.dismissed).length) * HEADER_HEIGHT + TOP_NAV_HEIGHT}rem)`,
            }}
            >
            {defs.length > 0 && [
              <SideNav
                {...this.props}
                key="SideNav"
                isFetching={sidenav.isFetching || isFetching}
                items={defsByCategory}
                path={path}
                project={project}
                sidenav={sidenav}
                />,
            <Outlet />
            ]}
          </Row>
        </Column>
      </Row>
    );
  }
}

export default connect(
  state => ({
    projects: state.projects,
    sidenav: state.sidenav,
    entityDefinitions: state.entityDefinitions,
    notifications: state.notifications,
    qcReports: state.qcReports,
  }),
)(withRouting(Browse));
